import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { UPDATE_TRUSTS_USER_MUTATION } from '../graphql/mutations/updateTrustsUser';
import { GET_TRUSTS_USERS } from '../graphql/queries/getTrustsUsers';

export interface UpdateTrustsUser {
  email: string;
  enabled?: boolean;
}

export const useUpdateTrustsUser = () => {
  const [updateTrustsUserMutation, { data, loading, error }] = useMutation(UPDATE_TRUSTS_USER_MUTATION, {
    refetchQueries: [{ query: GET_TRUSTS_USERS }]
  });

  const updateTrustsUser = async (dto: UpdateTrustsUser) => {
    const variables = { trustsUserUpdateDto: dto };
    try {
      await updateTrustsUserMutation({ variables });
      toast.success('User updated successfully!');
      return { error: false };
    } catch (err) {
      toast.error(`There was an error updating the user: ${(err as Error).message}`);
      return { error: true };
    }
  };

  return { updateTrustsUser, data, loading, error };
};
